export function initNumberPrototype() {
  Number.prototype.toTwoDigitsDecimal = function (): number {
    return Math.round(this * 100) / 100
  }
}
